import { useCallback } from "react"
import { Link, useNavigate } from "react-router-dom"
import styled from "styled-components"
import { Button, OutlineButton } from "~/components"
import { clearAuthToken } from "~/modules/authentication"
import Toast from "~/modules/toasts/Toast"
import { useTranslate } from "~/ur-react-hooks"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  width: 456px;
  padding: 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 8px;
`

const Title = styled.h3`
  margin: 0;
`

const Description = styled.p`
  line-height: 150%;
`

const StyledLink = styled.a`
  color: ${(props) => props.theme.colors.secondary50};
  text-decoration: underline;
`

export type CancelSubscriptionSuccessProps = {}

const CancelSubscriptionSuccess: React.FC<
  CancelSubscriptionSuccessProps
> = () => {
  const translations = useTranslate({
    title: "cancel-subscription-success.title",
    toastText: "cancel-subscription-success.toast-text",
    description: ["cancel-subscription-success.description", {}],
    contactForm: "cancel-subscription-success.contact-form",
    logout: "common.log-out",
    home: "common.home",
  })

  const navigate = useNavigate()

  const logout = useCallback(() => {
    clearAuthToken()
    navigate("/login")
  }, [navigate])

  return (
    <Layout>
      <Card>
        <Title>{translations.title}</Title>
        <Toast type="success" message="Abonnementet ble avsluttet" />
        <Description>
          {translations.description({
            contactLink: (
              <StyledLink href="mailto:kontakt@arbeidsark.no">
                kontakt@arbeidsark.no
              </StyledLink>
            ),
            contactForm: (
              <StyledLink
                href="https://arbeidsark.no/kontakt-oss"
                target="_blank"
              >
                {translations.contactForm}
              </StyledLink>
            ),
          })}
        </Description>
        <Link to="/home">
          <Button leftIcon="home" width="100%">
            {translations.home}
          </Button>
        </Link>
        <OutlineButton leftIcon="right-from-bracket" onClick={() => logout()}>
          {translations.logout}
        </OutlineButton>
      </Card>
    </Layout>
  )
}

export default CancelSubscriptionSuccess
